Vue.directive('scroll-loading', {
  inserted: function (el, binding) {
    const observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting === true) {
          binding.value();
        }
      },
      {
        threshold: [1],
      },
    );

    const trigger = document.createElement('div');
    el.after(trigger);
    observer.observe(trigger);
  },
});
